<template>
  <header class="header">
    <div class="header__left">
      <div class="header__logo">
        <nuxt-link :to="{ name: 'index' }">
          <img class="" src="/frontend/img/logo-c.svg" alt="会社手続きナビゲーター モチカケ">
        </nuxt-link>
      </div>
    </div>
    <div class="header__right">
      <div class="header__menu__sub">
        <ul>
          <li class="pc"><nuxt-link class="button button--primary" to="/resources">資料請求</nuxt-link></li>
          <li class="pc"><nuxt-link class="button button--primary" to="/auth/register">会員登録</nuxt-link></li>
          <li class="sp"><nuxt-link class="button button--primary" to="/auth/register">会員登録</nuxt-link></li>
        </ul>
      </div>
    </div>
</header>
</template>

<script>
  export default {
    name: 'f-header-lp-sub'
  }
</script>
